import { render, staticRenderFns } from "./Actia.vue?vue&type=template&id=da24e96e"
import script from "./Actia.vue?vue&type=script&lang=js"
export * from "./Actia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports